module.exports = __webpack_public_path__ + "img/ryzz-banner-pic.54cb2602.png";